export default {
  title: 'Customers',
  empty: {
    title: 'No customers',
    message: 'To create a customer, please refer to the documentation.'
  },
  details: {
    'no-friends': 'User doesn\'t have any friends'
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/customer.js